/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Observable, Observer } from 'rxjs';

import { GroupType } from '../../../models/group-type';
import { FunctionParameter } from '../../../models/function-parameter';
import { Property } from '../../../models/property';
import { PropertyType } from '../../../models/property-type';
import { ActionInstance } from '../../../models/action-instance';
import { LocationInstance } from '../../../models/location-instance';
import { ObjectInstance } from '../../../models/object-instance';
import { TagInstance } from '../../../models/tag-instance';
import { ZoneInstance } from '../../../models/zone-instance';
import { User } from '../../../models/user';

import { EntityService } from "../../../services/entity.service";
import { GroupService } from "../../../services/group.service";
import { LocationService } from "../../../services/location.service";
import { ObjectService } from "../../../services/object.service";
import { TagService } from "../../../services/tag.service";
import { UserService } from "../../../services/user.service";
import { ZoneService } from "../../../services/zone.service";
import { switchMap } from "rxjs/operators";

@Component({
  selector: 'app-function-parameter-editor',
  templateUrl: './function-parameter-editor.component.html'
})
export class FunctionParameterEditorComponent implements OnInit {

    @Input()
    action: ActionInstance;
    
    @Input()
    parameter: FunctionParameter;
    
    @Input()
    index: number;
    
    typeaheadValue: string;
    typeaheadLoading: boolean;
    typeaheadNoResults: boolean;
    entities: Observable<any>;

    parameterLabel: string;
    parameterType: PropertyType;
    
    constructor(private groupService: GroupService,
        private entityService: EntityService,
        private locationService: LocationService,
        private objectService: ObjectService,
        private tagService: TagService,
        private userService: UserService,
        private zoneService: ZoneService) {}


    ngOnInit(): void {
        console.log('onInit ----');
//        if (this.parameter != null) {
//            this.fn.
        
        this.index = this.index + 1;
        if (this.action.data != null) {
            const datum = this.action.data.find(d => d.property.property == 'param_' + this.index);
            this.parameterLabel = datum != null ? datum.value : 'N/A';
            this.parameterType = datum != null ? datum.property.type : null;
        }
        
        //KHT 08/17/2021 - updated to new ngx-bootstrap standard
        this.entities = new Observable((observer: Observer<string>) => {
            observer.next(this.typeaheadValue);
            }).pipe(
            switchMap((query: string) => {
                if(query){
                    return this.search(query);
                }
            })
        )

        this.loadReferenceValue();
    }

    getParameterLabel(): string {
        return "";
    }
    
    getValueLabel(): string {
        return this.typeaheadValue;
    }

    async loadReferenceValue(): Promise<void> {
        console.log('loadRef');
//        if (this.ruleCondition.propertyValue != null) {
//            switch (this.ruleCondition.propertyType) {
//                case PropertyType.OBJECT_REFERENCE:
//                    const object: ObjectInstance = await this.objectService.getObjectInstanceForId(Number(this.ruleCondition.propertyValue));
//                    if (object != null) {
//                        this.typeaheadValue = object.name;
//                    }
//                    
//                    break;
//                case PropertyType.LOCATION_REFERENCE:
//                    const location: LocationInstance = await this.locationService.getLocationInstanceById(Number(this.ruleCondition.propertyValue));
//                    if (location != null) {
//                        this.typeaheadValue = location.name;
//                    }
//    
//                    break;
//                case PropertyType.TAG_REFERENCE:
//                    const tag: TagInstance = await this.tagService.getTagInstanceById(Number(this.ruleCondition.propertyValue));
//                    if (tag != null) {
//                        this.typeaheadValue = tag.name;
//                    }
//    
//                    break;
//                case PropertyType.USER_REFERENCE:
//                    const user: User = await this.userService.getUserForId(Number(this.ruleCondition.propertyValue));
//                    if (user != null) {
//                        this.typeaheadValue = user.firstName + " " + user.lastName;
//                    }
//                    
//                    break;
//                case PropertyType.ZONE_REFERENCE:
//                    const zone: ZoneInstance = await this.zoneService.getZoneInstanceById(Number(this.ruleCondition.propertyValue));
//                    if (zone != null) {
//                        this.typeaheadValue = zone.name;
//                    }
//    
//                    break;
//            }
//        }
    }
    
    changeTypeaheadLoading(e: boolean): void {
        this.typeaheadLoading = e;
    }
    
    typeaheadOnSelect(e: TypeaheadMatch) {
        console.log('Selected value: ', e.item);
    }
    
    search(token: string) {
       return this.entityService.search(this.parameter.type, token);
//        if (this.parameter != null) {
//            if (this.parameterType == PropertyType.USER_REFERENCE) {
//              return this.entityService.searchUser(token);
//            else {
//              return this.entityService.search(this.parameter.type, token);
//            }
//        }

//        var propertyType: PropertyType;
//        
//        if (this.ruleCondition.propertyType == null) {
//            if (this.ruleCondition.sourceType == Type.TAG) {
//                propertyType = PropertyType.TAG_REFERENCE;
//            }
//            else if (this.ruleCondition.sourceType == Type.OBJECT) {
//                propertyType = PropertyType.OBJECT_REFERENCE;
//            }
//            else if (this.ruleCondition.sourceType == Type.USER) {
//                propertyType = PropertyType.USER_REFERENCE;
//            }
//        }
//        else {
//            propertyType = this.ruleCondition.propertyType;
//        }
//        
//        if (propertyType == PropertyType.USER_REFERENCE) {
//            return this.entityService.searchUser(token);
//        }
//        else {
//            return this.entityService.search(propertyType, token);
//        }
    }
}
